import React from "react";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";
import styles from "./authorization.module.scss";

const cx = classNames.bind(styles);

type AuthView = "signin" | "signup" | "verify" | "forgot" | "reset" | "invite";

interface BrandingPanelProps {
  view: AuthView;
}

const brandingTitles: Record<AuthView, string> = {
  signin: "welcomeBack",
  signup: "joinUs",
  invite: "joinUs",
  verify: "almostThere",
  forgot: "noWorries",
  reset: "createNewPassword",
};

const brandingSubtitles: Record<AuthView, string> = {
  signin: "signInToContinue",
  signup: "startLearningToday",
  invite: "startLearningToday",
  verify: "verifyYourEmail",
  forgot: "weWillHelpYou",
  reset: "setUpNewPassword",
};

export const BrandingPanel: React.FC<BrandingPanelProps> = ({ view }) => {
  const { t } = useTranslation();

  // The panel's one flourish is a highlighter stroke under the last word of the
  // headline. Splitting on the rendered string rather than hardcoding a word
  // keeps it working in every locale — the headlines differ per language and
  // per view, so there is no fixed word to mark.
  const title = t(brandingTitles[view]).trim();
  const words = title.split(/\s+/);
  const markedWord = words[words.length - 1];
  const leadingWords = words.slice(0, -1).join(" ");

  return (
    <div className={cx('brandingPanel')}>
      <div className={cx('brandingContent')}>
        <div className={cx('logo')}>
          <span className={cx('logoDeutsch')}>Nicolas</span>
          <span className={cx('logoMit')}> </span>
          <span className={cx('logoYehor')}>Smith</span>
        </div>
        <h1 className={cx('brandingTitle')}>
          {leadingWords && `${leadingWords} `}
          <span className={cx('markedWord')}>{markedWord}</span>
        </h1>
        <p className={cx('brandingSubtitle')}>
          {t(brandingSubtitles[view])}
        </p>
      </div>
      <div className={cx('brandingFooter')}>
        <p>{t("footer.copyright")}</p>
      </div>
    </div>
  );
};
